<template>
    <v-card :class="{'pa-3': $vuetify.breakpoint.xs, 'pa-5': $vuetify.breakpoint.smAndUp}" :width="$vuetify.breakpoint.mdAndUp ? 1100 : 'auto'">
        <v-form @submit.prevent="validate_send(idea)">
            <v-icon class="modal-close" @click.native="CLOSE_MODAL('ideas_bank_modal')">{{$t("закрыть")}}</v-icon>
            <v-card-title class="display-1 mb-4">{{$t("Предложить идею")}}</v-card-title>
            <v-layout mb-4 wrap>
                <v-flex sm6 xs12 :class="{'mb-4': $vuetify.breakpoint.xs, 'pr-4': $vuetify.breakpoint.smAndUp}">
                    <div class="grey-text mb-2">{{$t("Тема идеи")}} *</div>
                    <v-select
                        v-model.trim="$v.idea_theme.$model"
                        :items="themes"
                        solo
                        attach="js-bank-theme"
                        append-icon=""
                        :label="$t('Выберите из списка идей')"
                        class="input js-bank-theme"
                        :class="{ 'form-group--error': errors && !$v.idea_theme.required }"
                        required
                        @change="get_idea_theme($event)"
                    >
                      <template #append>
                        <v-icon aria-hidden="true" translate="no">
                          expand_more
                        </v-icon>
                      </template>
                    </v-select>
                </v-flex>
                <v-flex sm6 xs12>
                    <div class="grey-text mb-2">{{$t("Название идеи")}} *</div>
                    <inputBase :value="idea_title" :class="{ 'form-group--error': errors && !$v.idea_title.required }" @change="get_idea_title($event.target.value)" />
                </v-flex>
            </v-layout>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Опишите Ваш вопрос")}} *</div>
                    <textareaBase :value="idea_text" :placeholder="$t('Введите текст')" rows="4"
                                  required :class="{ 'form-group--error': errors && !$v.idea_text.required }"
                                  @change="get_idea_text($event.target.value)"
                    />
                </v-flex>
            </v-layout>
            <v-layout mb-4>
                <v-flex xs12>
                    <div class="grey-text mb-2">{{$t("Загрузите файлы")}}</div>
                    <inputUpload id="logo_upload" :placeholder="$t('Загрузить файл...')" :multiple="true"
                                 @input.native="send_files($event)"
                    />
                </v-flex>
            </v-layout>
            <v-layout v-if="errors" column class="my-2">
                <div v-if="!$v.idea_theme.required" class="mr-2 red-text">{{$t("Выберите тему")}}</div>
                <div v-if="!$v.idea_title.required" class="mr-2 red-text">{{$t("Введите название идеи")}}</div>
                <div v-if="!$v.idea_text.required" class="red-text">{{$t("Введите текст")}}</div>
            </v-layout>
            <v-card-actions>
                <v-layout align-center wrap>
                    <buttonRed :class="{'flex xs12 mr-0 mb-2': $vuetify.breakpoint.xs, 'mr-4': $vuetify.breakpoint.smAndUp}">{{$t("Предложить")}}</buttonRed>
                    <div class="grey-text">{{$t("* - поля, обязательные для заполнения")}}</div>
                </v-layout>
            </v-card-actions>
        </v-form>
    </v-card>
</template>

<script>
import {validationMixin} from 'vuelidate';
import {required} from 'vuelidate/lib/validators';
import buttonRed   from '@/components/ui/buttons/button_red';
import textareaBase from '@/components/ui/inputs/base/textarea';
import inputBase from '@/components/ui/inputs/base/input';
import inputUpload from '@/components/ui/inputs/typed/input_upload.vue';
import {mapGetters, mapMutations, mapActions} from 'vuex';


export default {
  components: {
    buttonRed,
    textareaBase,
    inputBase,
    inputUpload,
  },
  mixins     : [validationMixin],
  validations: {
    idea_theme: {
      required,
    },
    idea_title: {
      required,
    },
    idea_text: {
      required,
    },
  },
  data() {
    return {
      idea: {
        theme: 'null',
        title: '',
        text : '',
        files: [],
      },
      idea_theme: '',
      idea_title: '',
      idea_text : '',
      errors    : false,
    };
  },
  computed: {
    ...mapGetters('ideas_bank', [
      'ideas_bank_modal',
    ]),
    ...mapGetters('activity', [
      'themes',
      'ideas_bank_modal',
    ]),
  },
  beforeCreate() {
    document.documentElement.style.overflow = 'hidden';
  },
  beforeDestroy() {
    document.documentElement.style.overflow = 'auto';
  },
  methods: {
    ...mapMutations('ideas_bank', [
      'CLOSE_MODAL',
      'OPEN_MODAL',
    ]),
    ...mapActions('ideas_bank', [
      'send_idea',
    ]),
    get_idea_theme(ev) {
      this.idea.theme = ev;
    },
    get_idea_title(ev) {
      this.idea_title = ev;
      this.idea.title = ev;
    },
    get_idea_text(ev) {
      this.idea_text = ev;
      this.idea.text = ev;
    },
    send_files($event) {
      let files = $event.target.files;

      for (let i=0; i<files.length; i++) {
        let reader = new FileReader();
        reader.readAsDataURL(files[i]);
        reader.onload = () => {
          this.idea.files.push(reader.result);
        };
      }
    },
    validate_send(idea) {
      if (this.$v.$invalid) {
        this.errors = true;
      } else {
        this.send_idea(idea);
        this.errors = false;
      }
    },
  },


};
</script>
